'use es6';

import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import userInfo from 'hub-http/userInfo';
import { getPortalScopes } from '../data/PortalSettings';

var Auth = /*#__PURE__*/function () {
  _createClass(Auth, [{
    key: "createInstance",
    value: function createInstance() {
      return new Auth();
    }
  }]);

  function Auth() {
    _classCallCheck(this, Auth);

    this.data = {
      auth: null,
      user: null,
      gates: null,
      portal: null
    };
    this.initialized = false;
  }

  _createClass(Auth, [{
    key: "init",
    value: function init() {
      var _this = this;

      if (this.initialized) {
        throw new Error('Auth Utils: Cannot be initialized twice. Use getInstance() if you ' + 'need to create multiple instances.');
      }

      this.initialized = true;
      return Promise.all([userInfo(), getPortalScopes()]).then(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            _ref2$ = _ref2[0],
            user = _ref2$.user,
            gates = _ref2$.gates,
            portal = _ref2$.portal,
            portalScopes = _ref2[1].scopes;

        _this.data = {
          gates: gates,
          user: user,
          portal: Object.assign({}, portal, {
            scopes: portalScopes
          })
        };
        return _this.data;
      });
    }
  }, {
    key: "get",
    value: function get() {
      return this.data;
    }
  }]);

  return Auth;
}();

export default new Auth();